import React, {useState} from "react"

export default function Checkbox({name, value, label, checked, onChange})
{     
    const [fieldStatus , setFieldStatus] = useState(false)
    const [fieldClass, setFieldClass] = useState(checked ? 'stylized-checkbox checked' :'stylized-checkbox')

    const toggleStatus = (e) =>
    {
        setFieldStatus(!fieldStatus)
        toggleClass(e)
    }

    const toggleClass = (target) =>
    {
        if(fieldStatus)
        {
            setFieldStatus(false)
            setFieldClass('stylized-checkbox')
            onChange(value, 'remove')
            return
        }

        setFieldStatus(true)
        setFieldClass('stylized-checkbox checked')
        onChange(value, 'add')
    }
    
    return (
        <div className={fieldClass} onClick={toggleStatus} data-status={fieldStatus}>
            <div className="label">{label}</div>
        </div>    
    ) 
}